import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Moment from "moment";
import { addError } from "actions";
import { getGuardianStudentAssessments, getGuardianStudentAssignment, getGuardianStudentAssignmentAssessments } from "actions/assignments";
import { getCourse, getGuardianStudentGroup } from "actions/sections";
import { getReaderParameters } from "actions/user";
import { setPageTitle } from "actions/header";
import { getDescription } from "helpers/content";
import Message from "containers/SinglePages/Partials/Message";
import { getBlocksByReference } from "actions/blocks";
import ColorLabel from "components/Presentation/Cards/ColorLabel";
import FromNow from "components/Presentation/Dates/FromNow";
import PostContent from "components/Presentation/PostContent";
import AssessmentsConsumer from "components/BlockAssessments/Consumer";
import { Spinner, ColorLabelContainer } from "UI";
import { Immersive_Reader } from "UI/Icons";
import { Block, Flex, Button, translate, getActiveLanguage } from "@haldor/ui";
var ImmersiveReader = require("@microsoft/immersive-reader-sdk");
var HaldorAssignment = /*#__PURE__*/function (_Component) {
  function HaldorAssignment(props) {
    var _this;
    _classCallCheck(this, HaldorAssignment);
    _this = _callSuper(this, HaldorAssignment, [props]);
    _defineProperty(_this, "UNSAFE_componentWillMount", function () {
      _this.props.setPageTitle(_this.props.task.title);
    });
    _defineProperty(_this, "componentDidMount", function () {
      var activeStudent = _this.props.activeStudent;
      _this.props.getGuardianStudentAssignmentAssessments(_this.props.task.id).then(function () {
        _this.setState({
          loadingAssessments: false
        });
      });
      if (_this.props.task.associatedMatrices != null) {
        _this.props.task.associatedMatrices.forEach(function (matrix) {
          if (_this.getCourse(matrix.courseId) == null) {
            _this.props.getCourse(matrix.courseId);
          }
        });
      }
      _this.props.getGuardianStudentGroup(activeStudent.id, _this.props.task.sectionId).then(function () {
        _this.setState({
          loadingGroup: false
        });
      });
      if (_this.props.task.assessmentType == "SELF") {
        _this.setState({
          loadedSelfAssessment: true
        });
        _this.props.getGuardianStudentAssessments(activeStudent.id, _this.props.task.tasks[0].id).then(function () {
          _this.setState({
            loadingSelfAssessment: false
          });
        });
      }
      _this.props.getBlocksByReference(_this.props.task.id, "ASSIGNMENT").then(function () {
        _this.setState({
          loadingBlocks: false
        });
      });
    });
    _defineProperty(_this, "getCourse", function (courseId) {
      return _this.props.courses.find(function (course) {
        return course.id == courseId;
      });
    });
    _defineProperty(_this, "onConversationClose", function () {
      _this.setState({
        studentConversation: null
      });
    });
    _defineProperty(_this, "openConversation", function () {
      _this.setState({
        studentConversation: _this.props.activeStudent
      });
    });
    _defineProperty(_this, "pupilStatusIndicator", function (status) {
      var assessed = false;
      if (_this.props.assessments != null) {
        if (_this.props.assessments.length > 0) {
          assessed = true;
        }
      }
      if (assessed == false) {
        /**
         * Retrieve status from assignmentTaskStatus and render the correct icon with translated status text
         */
        var statusObject = _this.props.status.assignmentTaskStatus.find(function (type) {
          return type.id == status;
        });
        if (statusObject != null) {
          return _this.renderAssignmentTaskStatus(statusObject);
        }
      } else {
        return /*#__PURE__*/React.createElement("span", {
          className: "single-dot dot-green"
        }, _this.props.translate("Assessed"));
      }
      return null;
    });
    _defineProperty(_this, "assignmentIndicator", function (status) {
      if (status === "ASSIGNMENT_OPEN") {
        return /*#__PURE__*/React.createElement("span", {
          className: "single-dot dot-green"
        }, _this.props.translate("Open"));
      } else if (status === "ASSIGNMENT_CLOSED") {
        return /*#__PURE__*/React.createElement("span", {
          className: "single-dot dot-red"
        }, _this.props.translate("Closed"));
      } else if (status === "ASSIGNMENT_DRAFT") {
        return /*#__PURE__*/React.createElement("span", {
          className: "single-dot dot-gray"
        }, _this.props.translate("Draft"));
      } else if (status === "ASSIGNMENT_DELETED") {
        return /*#__PURE__*/React.createElement("span", {
          className: "single-dot dot-red"
        }, _this.props.translate("Deleted"));
      }
      return null;
    });
    _defineProperty(_this, "runImmersiveReader", function () {
      var task = _this.props.task;
      var data = {
        title: task.title,
        chunks: [{
          content: "<h1>" + task.title + "</h1>",
          mimeType: "text/html"
        }, {
          content: getDescription(task.description),
          mimeType: "text/html"
        }]
      };
      _this.props.getReaderParameters().then(function () {
        var reader = _this.props.reader;
        ImmersiveReader.launchAsync(reader.token, reader.subdomain, data, {
          uiLang: getActiveLanguage()
        })["catch"](function (error) {
          console.error("error", error);
          //trackImmersiveReaderError(error, currentUser.id);
        });
      });
    });
    /**
     * This function renders the correct icon and text for the current status of the assignment task
     * @param {Object} currentStatus 
     * @returns 
     */
    _defineProperty(_this, "renderAssignmentTaskStatus", function (currentStatus) {
      if (currentStatus == null) return null;
      var statusIcons = [{
        id: 'ASSIGNMENT_TASK_NOT_STARTED',
        url: '/dist/svg/Status_notStarted-ico.svg'
      }, {
        id: 'ASSIGNMENT_TASK_STARTED',
        url: '/dist/svg/Status_started-ico.svg'
      }, {
        id: 'ASSIGNMENT_TASK_SUBMITTED',
        url: '/dist/svg/Status_submitted-ico.svg'
      }, {
        id: 'ASSIGNMENT_TASK_NOT_COMPLETE',
        url: '/dist/svg/Status_notComplete-ico.svg'
      }, {
        id: 'ASSIGNMENT_TASK_CAN_DEVELOP',
        url: '/dist/svg/Status_canDevelop-ico.svg'
      }];
      var icon = statusIcons.find(function (icon) {
        return icon.id == currentStatus.id;
      });
      if (icon == null) return null;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          marginRight: '0.5rem'
        }
      }, /*#__PURE__*/React.createElement("img", {
        style: {
          width: '20px',
          marginRight: '0.3rem'
        },
        src: icon.url,
        alt: "task status"
      }), /*#__PURE__*/React.createElement("div", null, currentStatus.value));
    });
    _defineProperty(_this, "taskContent", function () {
      Moment.locale(getActiveLanguage());
      var _this$props = _this.props,
        translate = _this$props.translate,
        group = _this$props.group;
      if (_this.props.task != null) {
        var status = "";
        if (_this.props.status != null) {
          var statusObject = _this.props.status.assignmentTypes.find(function (type) {
            return type.id == _this.props.task.assignmentType;
          });
          if (statusObject != null) status = statusObject.value;
        }
        var conversationEnabled = false;
        if (group !== null && group !== void 0 && group.owners && (group === null || group === void 0 ? void 0 : group.owners.length) > 0) {
          conversationEnabled = _this.hasValidOwner(group.owners, _this.props.task.creator, group.schoolID.toString());
        }
        var conversation = null;
        if (_this.props.conversations != null && _this.props.profile != null) {
          conversation = _this.props.conversations.find(function (conv) {
            return conv.memberships.find(function (member) {
              return member.membershipID == _this.props.profile.id;
            });
          });
        }
        var assessmentBlocks = [];
        var assessment = null;
        if (_this.props.blocks != null) {
          assessmentBlocks = _toConsumableArray(_this.props.blocks).filter(function (block) {
            return block.type == "Haldor.Blocks.AssessmentBlock";
          });
        }
        if (_this.props.assessments != null && !_this.state.loadingAssessments) {
          assessment = _this.props.assessments.find(function (assessment) {
            return assessment.studentId == _this.props.activeStudent.id;
          });
        }
        return /*#__PURE__*/React.createElement("div", {
          className: "single-task"
        }, /*#__PURE__*/React.createElement("div", {
          className: "single-section form left-side"
        }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
          className: "title"
        }, translate("Assignment information")), /*#__PURE__*/React.createElement(Link, {
          to: "#",
          onClick: _this.runImmersiveReader
        }, /*#__PURE__*/React.createElement("div", {
          className: "reader trigger"
        }, /*#__PURE__*/React.createElement(Immersive_Reader, null), " ", translate("Immersive Reader"))), /*#__PURE__*/React.createElement(PostContent, null, getDescription(_this.props.task.description)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          className: "card-meta",
          style: {
            marginRight: "0.55rem"
          }
        }, status), _this.props.task.studentAssessment ? /*#__PURE__*/React.createElement("div", {
          className: "card-meta",
          style: {
            marginRight: "0.55rem"
          }
        }, translate("Student assessment")) : null, /*#__PURE__*/React.createElement(FromNow, null, _this.props.task.dueDate), /*#__PURE__*/React.createElement("div", {
          className: "clearfix"
        })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
          className: "title",
          style: {
            marginTop: "1rem"
          }
        }, translate("Group")), _this.props.task.sectionTitle), /*#__PURE__*/React.createElement("span", {
          style: {
            marginTop: "1rem"
          },
          className: "title"
        }, translate("Status")), _this.props.task.created == "0001-01-01T00:00:00" ? /*#__PURE__*/React.createElement("div", null, translate("Assignment is being created")) : /*#__PURE__*/React.createElement("div", null, _this.renderAssignmentTaskStatus(_this.props.task.tasks[0].status), _this.pupilStatusIndicator(_this.props.task.tasks[0].status), /*#__PURE__*/React.createElement("div", {
          className: "clearfix"
        })), /*#__PURE__*/React.createElement("div", {
          style: {
            marginTop: "1rem"
          }
        }), /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement("span", {
          className: "title",
          style: {
            display: "block"
          }
        }, translate("Start")), Moment.utc(_this.props.task.startDate).local().format("D MMM H:mm")), /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement("span", {
          className: "title",
          style: {
            display: "block"
          }
        }, translate("End")), Moment.utc(_this.props.task.dueDate).local().format("D MMM H:mm"))), _this.props.task.courses.length > 0 ? /*#__PURE__*/React.createElement("div", {
          style: {
            marginTop: "1rem"
          }
        }, /*#__PURE__*/React.createElement("span", {
          className: "title",
          style: {
            marginTop: "1rem"
          }
        }, translate("Subject_course")), /*#__PURE__*/React.createElement(ColorLabelContainer, null, _this.props.task.courses.map(function (course) {
          var text = course.year != null ? course.title + " " + course.year : course.title;
          return /*#__PURE__*/React.createElement(ColorLabel, {
            key: "single_assignment_course-".concat(course.id),
            tooltip: text,
            color: course.colorCode
          });
        }))) : null, _this.props.activeStudent != null && _this.props.activeStudent.services.conversations && conversationEnabled ? /*#__PURE__*/React.createElement(Button, {
          type: "secondary",
          onClick: _this.openConversation,
          style: {
            marginTop: "1rem",
            position: "relative"
          }
        }, _this.props.translate("Conversation"), conversation != null && conversation.unreadMessages > 0 ? /*#__PURE__*/React.createElement("div", {
          className: "badge"
        }, /*#__PURE__*/React.createElement("span", null, conversation.unreadMessages)) : null) : null)), /*#__PURE__*/React.createElement("div", {
          className: "single-actions right-side"
        }), /*#__PURE__*/React.createElement("div", {
          style: {
            clear: "both"
          }
        }), /*#__PURE__*/React.createElement("div", {
          className: "single-section-divider"
        }), _this.props.activeStudent != null && _this.props.activeStudent.services.conversations ? /*#__PURE__*/React.createElement("div", {
          className: "single-section"
        }, /*#__PURE__*/React.createElement(Message, {
          assignment: _this.props.task,
          activeUser: _this.state.studentConversation,
          onClose: _this.onConversationClose
        })) : null, /*#__PURE__*/React.createElement("div", {
          className: "single-section"
        }, _this.state.loadingBlocks ? /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }) : /*#__PURE__*/React.createElement(AssessmentsConsumer, {
          fields: assessmentBlocks,
          assessment: assessment
        })));
      }
      return null;
    });
    _this.state = {
      taskId: _this.props.match.params.assignmentId,
      task: null,
      tasks: [],
      isStudent: false,
      loadingGroup: true,
      loadingBlocks: true,
      loadingAssessments: true,
      loadingSelfAssessment: false,
      studentConversation: null
    };
    return _this;
  }
  _inherits(HaldorAssignment, _Component);
  return _createClass(HaldorAssignment, [{
    key: "renderKnowledgeRequirementsHeader",
    value: function renderKnowledgeRequirementsHeader() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
        style: {
          fontWeight: 500
        },
        className: "matrix-knowledge-req-title"
      }, this.props.translate("Learning goals")));
    }
  }, {
    key: "renderMembersForStudent",
    value: function renderMembersForStudent() {
      if (this.state.task != null) {
        if (this.state.task.tasks[0] != null) {
          return this.state.task.tasks[0].assignedUsers.map(function (student) {
            return /*#__PURE__*/React.createElement("div", null, "".concat((student === null || student === void 0 ? void 0 : student.firstName) || '', " ").concat((student === null || student === void 0 ? void 0 : student.lastName) || ''));
          });
        }
      }
      return null;
    }
  }, {
    key: "hasNonStudentRole",
    value: function hasNonStudentRole(roles, referenceId) {
      return roles.some(function (role) {
        return role.referenceId === referenceId && role.roleId.toLowerCase() !== "student";
      });
    }
  }, {
    key: "hasValidOwner",
    value: function hasValidOwner(sectionOwners, creatorId, referenceId) {
      var _this2 = this;
      return sectionOwners.some(function (user) {
        return user.userId === creatorId && _this2.hasNonStudentRole(user.roles, referenceId);
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.task != null) {
        return /*#__PURE__*/React.createElement("div", null, this.taskContent());
      }
      return /*#__PURE__*/React.createElement(Spinner, {
        center: true
      });
    }
  }]);
}(Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    task: state.assignments.assignment,
    activeStudent: state.User.activeStudent,
    courses: state.groups.courses,
    assessments: state.assignments.assessments,
    profile: state.profile.profile,
    status: state.base.status,
    selfAssessment: state.assignments.selfAssessment,
    conversations: state.Conversation.referenceConversations,
    reader: state.User.reader,
    group: state.groups.activeGroup,
    translate: translate(state.Languages.translations),
    blocks: state.Blocks.reference
  };
};
export default connect(mapStateToProps, {
  getGuardianStudentAssignment: getGuardianStudentAssignment,
  addError: addError,
  getGuardianStudentAssignmentAssessments: getGuardianStudentAssignmentAssessments,
  getGuardianStudentAssessments: getGuardianStudentAssessments,
  getReaderParameters: getReaderParameters,
  setPageTitle: setPageTitle,
  getCourse: getCourse,
  getGuardianStudentGroup: getGuardianStudentGroup,
  getBlocksByReference: getBlocksByReference
})(HaldorAssignment);